import { ChakraProvider } from '@chakra-ui/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'components'
import { ColorModeProvider, PortalProvider, PostHogProvider } from 'components/providers'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { system } from 'utils'
import App from './App.tsx'
import './index.css'

const queryClient = new QueryClient()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider>
      <ChakraProvider value={system}>
        <ColorModeProvider>
          <PortalProvider>
            <QueryClientProvider client={queryClient}>
              <App />
            </QueryClientProvider>
            <Toaster />
          </PortalProvider>
        </ColorModeProvider>
      </ChakraProvider>
    </PostHogProvider>
  </React.StrictMode>
)
